import { render, staticRenderFns } from "./blockMinus.vue?vue&type=template&id=61fdd2e9&"
import script from "./blockMinus.vue?vue&type=script&lang=js&"
export * from "./blockMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports